import { GroupeInfo } from '../store/types';

export const convertGroupsToTable = (groups: GroupeInfo[]) => groups.map((groupe) => ({
  ...groupe,
  key: groupe.id,
}));
